exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.gallary_image[data-v-901c4c34] {\r\n  width: 180px;\r\n  height: 180px;\r\n  display: inline;\r\n  margin: 2px 2px;\r\n  cursor: pointer;\n}\n.remove[data-v-901c4c34] {\r\n    position: relative;\r\n    margin-left: 5px;\r\n    bottom: 75px;\r\n    left: 180px;\n}\n.remove i[data-v-901c4c34] {\r\n    font-size: 20px;\r\n    color: #FF5722;\r\n    opacity: 0.5;\r\n    cursor: pointer;\n}\r\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-901c4c34","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Common/image-upload/ViewerTape.vue
// module id = pwoZ
// module chunks = 1